import { render, staticRenderFns } from "./facture.vue?vue&type=template&id=524ee491&scoped=true"
import script from "./facture.vue?vue&type=script&lang=js"
export * from "./facture.vue?vue&type=script&lang=js"
import style0 from "./facture.vue?vue&type=style&index=0&id=524ee491&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524ee491",
  null
  
)

export default component.exports